import * as Yup from "yup";

export const MIN_PROPERTY_AREA_M2 = 1;
export const AREA_REQUIRED_MESSAGE = "Área obrigatória";
export const AREA_MIN_MESSAGE = "A área útil deve ser no mínimo 1 m²";

export function parseAreaSquareMeters(value: unknown): number | null {
  if (value == null) return null;

  const text = String(value)
    .replace(/m²/gi, "")
    .replace(/m2/gi, "")
    .replace(/\s/g, "")
    .replace(",", ".")
    .trim();

  if (text === "" || text === "null" || text === "undefined") return null;

  const parsed = Number(text);
  if (!Number.isFinite(parsed)) return null;
  return parsed;
}

export function yupPropertyAreaString() {
  return Yup.string()
    .required(AREA_REQUIRED_MESSAGE)
    .test("min-useful-area", AREA_MIN_MESSAGE, (value) => {
      if (value == null || String(value).trim() === "") return true;
      const parsed = parseAreaSquareMeters(value);
      return parsed != null && parsed >= MIN_PROPERTY_AREA_M2;
    });
}
